import { Helmet } from "react-helmet";
import faviconLookup from "../../../../assets/img/LUFP_V1/favicon.ico";
import faviconScanandClaim from "../../../../assets/img/LUFP_V1/scan-claim-favicon.png";
import faviconOptimusClaims from "../../../../assets/img/Optimus-claims/Favicon.png";
import faviconDirectRefunds from "../../../../assets/img/Direct_refunds/favivon.png";
import faviconOnlineFinanceClaims from "../../../../assets/img/Online-finance-claims/favicon.png";
import faviconSavvyFinance from "../../../../assets/img/LUFP_SVY_V2/favicon-32x32.png";
import faviconUnfairFinance from "../../../../assets/img/Unfair-finance/Unfair-logo.png";
import faviconMyReclaim from "../../../../assets/img/Myreclaim/myreclaim-logo-wh.png";
import faviconJustera from "../../../../assets/img/RJ_V1/favicon.ico";
const HelmetBasedOnDomain = () => {
    const domainName = window.location.hostname;
    const domainPath = window.location.pathname;
    let favicon;
    let brandName;
    if (domainName === 'localhost' || domainName.includes('lookupfinance.co.uk')) {
        favicon = faviconLookup;
        brandName = 'LookUp Finance';
    }else if(domainName.includes('scanandclaim.co.uk')){
        favicon = faviconScanandClaim;
        brandName = 'Scan & Claim';
    }else if(domainName.includes('optimus-claims.co.uk')){
        favicon = faviconOptimusClaims;
        brandName = 'Optimus Claims';
    }else if(domainName.includes('direct-refunds.co.uk')){
        favicon = faviconDirectRefunds;
        brandName = 'Direct Refunds';
    }else if(domainName.includes('onlinefinanceclaims.co.uk')){
        favicon = faviconOnlineFinanceClaims;
        brandName = 'Online Finance Claims';
    } else if(domainName.includes('savvyfinances.co.uk')){
        favicon = faviconSavvyFinance;
        brandName = 'Savvy Finances';
    }else if(domainName.includes('unfairfinance.co.uk')){
        favicon = faviconUnfairFinance;
        brandName = 'Unfair Finance';
    }else if(domainName.includes('myreclaim.co.uk')){
        favicon = faviconMyReclaim;
        brandName = 'My Reclaim';
    }else if(domainName.includes('justera.co.uk')){
        favicon = faviconJustera;
        brandName = 'Justera';
    }
    else {
        favicon = faviconLookup;
        brandName ="LookUp Finance"
    }
    if(domainPath.includes('lead-summary/dashboard')){
        brandName = 'Olton Alexander';
    }else if(domainPath.includes('hsl/dashboard')){
        brandName = 'Harrington Sinclair Law';
    }
    return (
        <Helmet>
            <link rel="icon" href={favicon} />
            <title>{brandName}</title>
        </Helmet>
    )
}

export default HelmetBasedOnDomain;